import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TOOLTIP_COMPONENT_DATA } from '@campaign-portal/components-library';
import { MessagePurpose } from '@campaign-portal/namespace/common/enums';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-viber-priority',
	templateUrl: './viber-priority.component.html',
	styleUrls: ['./viber-priority.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule],
	standalone: true,
})
export class ViberPriorityComponent {
	readonly data = {
		[MessagePurpose.TRANSACTION]: {
			type: `enums.${MessagePurpose.TRANSACTION}`,
			options: [
				'campaigns.viber.order',
				'campaigns.viber.delivery',
				'campaigns.viber.registration',
				'campaigns.viber.boarding',
				'campaigns.viber.meetings',
			],
		},
		[MessagePurpose.PROMOTION]: {
			type: `enums.${MessagePurpose.PROMOTION}`,
			options: [
				'campaigns.viber.discounts',
				'campaigns.viber.coupons',
				'campaigns.viber.offers',
				'campaigns.viber.birthday',
				'campaigns.viber.loyalty',
				'campaigns.viber.reminders',
			],
		},
	};

	constructor(@Inject(TOOLTIP_COMPONENT_DATA) public readonly purpose: MessagePurpose) {}
}
